// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1a0xC","inputWrap":"Table_inputWrap__30spf","col":"Table_col__vQDzM","bmiTooltip":"Table_bmiTooltip__2_TVo"};